/** Tenant detail — Devices tab (TenantDevices.vue) */
export default {
  tenantDevicesPage: {
    cardElectric: 'Smart electricity meters',
    cardWater: 'Smart water meters',
    cardAir: 'Air conditioning',
    cardLighting: 'Lighting',
    cardDoorlock: 'Smart door lock',
    cardStatsDedicatedGroups: 'Dedicated {dedicated} · Share groups {groups}',
    cardLightingStats: 'Groups -- Lights --',
    cardDoorlockPlaceholder: '--',
    sectionDedicatedElectric: 'Dedicated meters',
    sectionDedicatedWater: 'Dedicated water meters',
    sectionDedicatedAir: 'Dedicated AC',
    sectionShareGroup: 'Share groups',
    btnBindUnbindElectric: 'Bind / unbind meter',
    btnBindUnbindWater: 'Bind / unbind water meter',
    btnBindUnbindAir: 'Bind / unbind AC',
    btnBindUnbindShare: 'Bind / unbind share group',
    colSerial: 'Serial no.',
    colDeviceName: 'Device name',
    colType: 'Type',
    colPayMode: 'Payment mode',
    colSwitchState: 'Breaker state',
    colOnline: 'Online',
    colLastDataTime: 'Last update',
    colActions: 'Actions',
    colWaterPrice: 'Water tariff',
    colSettleMode: 'Settlement',
    colBindTime: 'Bound at',
    colShareGroupId: 'Group ID',
    colShareGroupName: 'Group name',
    colShareMethod: 'Share method',
    colShareDevices: 'Devices',
    colShareTenants: 'Tenants',
    colUpdatedAt: 'Updated',
    colCreatedAt: 'Created',
    colShareArea: 'Shared area',
    colActualShareArea: 'Actual shared area',
    colPowerState: 'Power',
    colRunMode: 'Mode',
    colTargetTemp: 'Setpoint',
    colRoomTemp: 'Room temp.',
    tagDedicated: 'Dedicated',
    tagShared: 'Shared',
    tagPrepaid: 'Prepaid',
    tagForceControl: 'Forced',
    switchOn: 'Close (on)',
    switchOff: 'Open (off)',
    online: 'Online',
    offline: 'Offline',
    powerOn: 'On',
    powerOff: 'Off',
    settleAdd: '+ Add',
    settleSubtract: '- Subtract',
    waterBindDedicated: 'Dedicated',
    waterBindShared: 'Shared',
    waterBindFormula: 'Formula',
    noPrice: 'No tariff',
    btnDetail: 'Details',
    emptyNotOpen: 'Coming soon',
    drawerBoundMeters: 'Bound meters',
    drawerSelectableMeters: 'Available meters',
    drawerBoundShares: 'Bound share groups',
    drawerSelectableShares: 'Available share groups',
    drawerBoundWaters: 'Bound water meters',
    drawerSelectableWaters: 'Available water meters',
    drawerBoundWaterShares: 'Bound water share groups',
    drawerSelectableWaterShares: 'Available water share groups',
    drawerBoundAirs: 'Bound AC units',
    drawerSelectableAirs: 'Available AC units',
    drawerBoundAirShares: 'Bound share groups',
    drawerSelectableAirShares: 'Available share groups',
    phSearchMeter: 'Search by meter name or serial',
    phSearchWater: 'Search by water meter name or serial',
    phSearchAir: 'Search by AC name or serial',
    phSearchShare: 'Search by share group name',
    labelSerialShort: 'Serial:',
    labelArea: 'Area:',
    labelShareArea: 'Shared area:',
    labelSettleMode: 'Settlement:',
    labelCreatedAt: 'Created:',
    phInput: 'Enter',
    phSelect: 'Select',
    btnBind: 'Bind',
    btnUnbind: 'Unbind',
    emptyNoBoundMeters: 'No bound meters',
    emptyNoSelectableMeters: 'No meters available to bind',
    emptyNoBoundShares: 'No bound share groups',
    emptyNoSelectableShares: 'No share groups available to bind',
    emptyNoBoundWaters: 'No bound water meters',
    emptyNoSelectableWaters: 'No water meters available to bind',
    emptyNoBoundWaterShares: 'No bound water share groups',
    emptyNoSelectableWaterShares: 'No water share groups available to bind',
    emptyNoBoundAirs: 'No bound AC units',
    emptyNoSelectableAirs: 'No AC units available to bind',
    emptyNoBoundAirShares: 'No bound share groups',
    emptyNoSelectableAirShares: 'No share groups available to bind',
    dialogDrawerElectric: 'Meter bind / unbind',
    dialogDrawerElectricGroup: 'Electric share group bind / unbind',
    dialogDrawerWater: 'Water meter bind / unbind',
    dialogDrawerWaterGroup: 'Water share group bind / unbind',
    dialogDrawerAir: 'AC bind / unbind',
    dialogDrawerAirGroup: 'AC share group bind / unbind',
    dialogDrawerDefault: 'Bind devices',
    switchDialogMeter: 'Meter',
    switchDialogAction: 'Action',
    switchDialogPhone: 'Phone',
    switchDialogCode: 'Verification code',
    phSmsCode: 'Enter code',
    sendSms: 'Send code',
    smsCountdown: '{seconds}s',
    copyHint: 'Click to copy',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    airEditTitle: 'Edit AC',
    labelDeviceName: 'Device name',
    labelDeviceType: 'Device type',
    labelShareBindType: 'Share type',
    labelRemark: 'Remark',
    phDeviceName: 'Enter device name',
    phDeviceType: 'Select device type',
    phShareBindType: 'Select share type',
    phRemark: 'Enter remark',
    airTypeVrf: 'VRF',
    shareTypeArea: 'By area',
    shareTypeEnergy: 'By energy',
    shareTypeUnknown: 'Unknown',
    airModeAuto: 'Auto',
    airModeHeat: 'Heat',
    airModeCool: 'Cool',
    airModeFan: 'Fan',
    airModeDry: 'Dry',
    fanAuto: 'Auto',
    fanLow: 'Low',
    fanMid: 'Medium',
    fanHigh: 'High',
    airTypeUnknown: 'Unknown',
    switchVerifyTitleDefault: 'Breaker operation verification',
    switchVerifyTitleSuffix: ' verification',
    titleTip: 'Notice',
    btnOk: 'OK',
    btnCancelPlain: 'Cancel',
    msgFeatureNotOpen: 'This feature is not available yet',
    msgLoadFail: 'Failed to load data. Please try again.',
    msgNoBindPerm: 'No permission to bind',
    msgEditOk: 'Saved',
    msgEditFail: 'Save failed',
    msgNothingToCopy: 'Nothing to copy',
    msgSerialCopied: 'Serial copied',
    msgCopyFail: 'Copy failed',
    msgFetchElectricFail: 'Failed to load dedicated meters',
    msgFetchElectricGroupFail: 'Failed to load electric share groups',
    msgNoSwitchPerm: 'No permission to operate breaker',
    confirmPrepaidToForceBody: 'This meter is in prepaid mode. It must be switched to forced-control mode before breaker operations. Change now?',
    msgPayModeOk: 'Payment mode updated',
    msgPayModeFail: 'Failed to update payment mode',
    msgNoPhone: 'No phone number on file',
    msgSmsSent: 'Verification code sent',
    msgSmsSendFail: 'Failed to send code',
    msgEnterCode: 'Enter verification code',
    confirmSwitchBody: 'Operate breaker on meter "{name}" — {action}?',
    msgSwitchOk: '{action} succeeded',
    msgSwitchFail: '{action} failed',
    msgFetchWaterFail: 'Failed to load dedicated water meters',
    msgFetchWaterGroupFail: 'Failed to load water share groups',
    msgFetchAirFail: 'Failed to load dedicated AC units',
    msgFetchAirGroupFail: 'Failed to load AC share groups',
    msgFetchMeterBindFail: 'Failed to load meter bind data',
    msgBindOk: 'Bound successfully',
    msgBindFail: 'Bind failed',
    msgBindMeterFail: 'Failed to bind meter',
    confirmUnbindMeter: 'Unbind meter {name}?',
    msgUnbindOk: 'Unbound successfully',
    msgUnbindFail: 'Unbind failed',
    msgUnbindMeterFail: 'Failed to unbind meter',
    msgFetchShareBindFail: 'Failed to load share group bind data',
    msgInvalidShareArea: 'Enter a valid shared area',
    msgBindShareFail: 'Failed to bind share group',
    confirmUnbindShare: 'Unbind share group {name}?',
    msgUnbindShareFail: 'Failed to unbind share group',
    msgFetchWaterBindFail: 'Failed to load water meter bind data',
    msgBindWaterFail: 'Failed to bind water meter',
    confirmUnbindWater: 'Unbind water meter {name}?',
    msgUnbindWaterFail: 'Failed to unbind water meter',
    msgFetchWaterShareBindFail: 'Failed to load water share group bind data',
    msgBindWaterShareFail: 'Failed to bind water share group',
    confirmUnbindWaterShare: 'Unbind water share group {name}?',
    msgUnbindWaterShareFail: 'Failed to unbind water share group',
    msgFetchAirBindFail: 'Failed to load AC bind data',
    msgBindAirFail: 'Failed to bind AC',
    confirmUnbindAir: 'Unbind AC {name}?',
    msgUnbindAirFail: 'Failed to unbind AC',
    msgFetchAirShareBindFail: 'Failed to load AC share group bind data',
    msgBindAirShareFail: 'Failed to bind AC share group',
    confirmUnbindAirShare: 'Unbind AC share group {name}?',
    msgUnbindAirShareFail: 'Failed to unbind AC share group'
  }
}
